<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { BrowserMultiFormatReader } from "@zxing/browser";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const videoElement = ref(null);
const qrCodeResult = ref(""); 
let codeReader = new BrowserMultiFormatReader();
let selectedDeviceId = null;

onMounted(() => {
  getCameras();
});

onUnmounted(() => {
  stopScanning();
});

// Get available cameras
const getCameras = async () => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoInputDevices = devices.filter(device => device.kind === "videoinput");

    if (videoInputDevices.length === 0) {
      console.error("No camera devices found.");
      return;
    }

    selectedDeviceId = videoInputDevices[0].deviceId; // Select the first camera
  } catch (error) {
    console.error("Error accessing camera:", error);
  }
};

// Start scanning
const startScanning = () => {
  if (!selectedDeviceId || !videoElement.value) {
    console.error("No camera found.");
    return;
  }

  codeReader.decodeFromVideoDevice(selectedDeviceId, videoElement.value, (result, error) => {
    if (result) {
      qrCodeResult.value = result.getText();
      console.log("QR Code Detected:", result.getText());
      Swal.fire({
              title: "",
              text: result.getText(),
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            });
    }
    if (error) {
      console.error(error);
    }
  });
};

// Stop scanning
const stopScanning = () => {
  if (videoElement.value && videoElement.value.srcObject instanceof MediaStream) {
    const stream = videoElement.value.srcObject;
    stream.getTracks().forEach(track => track.stop()); // Stop each track
    videoElement.value.srcObject = null; // Clear video feed
  }
};
</script>

<template>
  <div>
    <h2>QR Code Scanner</h2>
    <video ref="videoElement" style="width: 100%; border: 2px solid black;"></video>
    <p v-if="qrCodeResult">Scanned QR Code: {{ qrCodeResult }}</p>
    <button @click="startScanning">Start Scanning</button>
    <button @click="stopScanning">Stop Scanning</button>
  </div>
</template>